"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateStepNavigation = void 0;
const uuid_1 = require("uuid");
/**
 * This migration got introduced because steps were a linear array. With the choices feature
 * we introduce the navigation object.
 */
const migrateStepNavigation = async (dialog) => {
    const steps = dialog.scenes.scene1.branches.start.steps;
    const ids = steps.map((_s) => (0, uuid_1.v4)());
    const newSteps = steps.map((step, index) => {
        const id = ids[index];
        return {
            ...step,
            navigation: {
                id,
                previous: ids[index - 1],
                next: ids[index + 1],
            },
        };
    });
    return {
        ...dialog,
        scenes: {
            ...dialog.scenes,
            scene1: {
                ...dialog.scenes.scene1,
                branches: {
                    ...dialog.scenes.scene1.branches,
                    start: {
                        ...dialog.scenes.scene1.branches.start,
                        initialStep: ids[0],
                        steps: newSteps,
                    },
                },
            },
        },
    };
};
exports.migrateStepNavigation = migrateStepNavigation;
//# sourceMappingURL=migrateStepNavigation.js.map